import { createTheme } from "@mui/material/styles";
import { pxToRem } from "@lib/hlibs/react-web/func";
import SpoqaHanSansNeoBold from "@assets/fonts/SpoqaHanSansNeo-Bold.ttf";
import SpoqaHanSansNeoRegular from "@assets/fonts/SpoqaHanSansNeo-Regular.ttf";
import SpoqaHanSansNeoMedium from "@assets/fonts/SpoqaHanSansNeo-Medium.ttf";
import SpoqaHanSansNeoLight from "@assets/fonts/SpoqaHanSansNeo-Light.ttf";

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 320,
      sm: 480,
      md: 768,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: "#59AFFF",
      light: "#D9EEFD",
      dark: "#129BFF",
      contrastText: "#fff",
    },
    secondary: {
      main: "#FFC64A",
      light: "#FFE5AB",
      dark: "#FEB343",
      contrastText: "#fff",
    },
    info: {
      main: "#424242",
    },
    error: {
      main: "#FF5050",
    },
    grey: {
      // 50: "#F5F6F8", // light gray
      // 100: "#FAFAFA", // very gray
      200: "#FAFAFC", // line gray
      300: "#F6F6F8", // line gray
      400: "#EEEEEF", // Mid Dark
      500: "#DDDDDF", // Mid Dark
      600: "#9A9A9B", // Black
      700: "#686869", // Black
      800: "#424242", // Black
      900: "#000000", // Black
    },
    background: {
      default: "#FAFAFB",
      paper: "#ffffff",
    },
  },
  overrides: {
    MuiButton: {
      raisedPrimary: {
        color: "white",
      },
    },
  },
  typography: {
    fontFamily: [
      "SpoqaHanSansNeo",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'SpoqaHanSansNeo';
          font-style: normal;
          font-display: swap;
          font-weight:700;
          src: local('SpoqaHanSansNeoBold'), url(${SpoqaHanSansNeoBold}) format('truetype');
          unicode-range: U+AC00-D7A3;
        }
        @font-face {
          font-family: 'SpoqaHanSansNeo';
          font-style: normal;
          font-display: swap;
          font-weight:500;
          src: local('SpoqaHanSansNeoMedium'), url(${SpoqaHanSansNeoMedium}) format('truetype');
          unicode-range: U+AC00-D7A3;
        }
        @font-face {
          font-family: 'SpoqaHanSansNeo';
          font-style: normal;
          font-display: swap;
          font-weight:400;
          src: local('SpoqaHanSansNeoRegular'), url(${SpoqaHanSansNeoRegular}) format('truetype');
          unicode-range: U+AC00-D7A3;
        }
        @font-face {
          font-family: 'SpoqaHanSansNeo';
          font-style: normal;
          font-display: swap;
          font-weight:300;
          src: local('SpoqaHanSansNeoLight'), url(${SpoqaHanSansNeoLight}) format('truetype');
          unicode-range: U+AC00-D7A3;
        }
     
      `,
    },
  },
});

theme.typography.h1 = {
  fontSize: pxToRem(36),
  lineHeight: "48px",
  wordBreak: "break-all",
  fontFamily: [
    "SpoqaHanSansNeo",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  [theme.breakpoints.up("xs")]: {
    // 320px 이하
    fontSize: pxToRem(32),
    lineHeight: "45px",
  },
  [theme.breakpoints.up("sm")]: {
    // 480px ~ 320px
    fontSize: pxToRem(32),
    lineHeight: "45px",
  },
  [theme.breakpoints.up("md")]: {
    // 769~1200 사이
    fontSize: pxToRem(32),
    lineHeight: "45px",
  },
  [theme.breakpoints.up("lg")]: {
    // 1201~1920 사이
    fontSize: pxToRem(32),
    lineHeight: "45px",
  },
  [theme.breakpoints.up("xl")]: {
    // 1920 이상
    fontSize: pxToRem(32),
    lineHeight: "45px",
  },
};

theme.typography.h2 = {
  fontSize: pxToRem(22),
  lineHeight: "34px",
  wordBreak: "break-all",
  fontFamily: [
    "SpoqaHanSansNeo",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  [theme.breakpoints.up("xs")]: {
    // 320 이하
    fontSize: pxToRem(22),
    lineHeight: "34px",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: pxToRem(22),
    lineHeight: "34px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: pxToRem(22),
    lineHeight: "34px",
  },
  [theme.breakpoints.up("xl")]: {
    // 1201~1920 사이
    fontSize: pxToRem(22),
    lineHeight: "34px",
  },
  [theme.breakpoints.up("xl")]: {
    fontSize: pxToRem(22),
    lineHeight: "34px",
  },
};
//large body
theme.typography.h3 = {
  fontSize: pxToRem(16),
  lineHeight: "28px",
  wordBreak: "break-all",
  fontFamily: [
    "SpoqaHanSansNeo",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),

  [theme.breakpoints.up("xs")]: {
    // 320 이하
    fontSize: pxToRem(16),
    lineHeight: "28px",
  },
  [theme.breakpoints.up("sm")]: {
    // 320 ~480
    fontSize: pxToRem(16),
    lineHeight: "28px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: pxToRem(16),
    lineHeight: "28px",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: pxToRem(16),
    lineHeight: "28px",
  },
  [theme.breakpoints.up("xl")]: {
    fontSize: pxToRem(16),
    lineHeight: "28px",
  },
};

theme.typography.button = {
  fontSize: pxToRem(16),
  lineHeight: "28px",
  wordBreak: "break-all",
  fontFamily: [
    "SpoqaHanSansNeo",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  [theme.breakpoints.up("xs")]: {
    fontSize: pxToRem(14),
    lineHeight: "24px",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: pxToRem(14),
    lineHeight: "24px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: pxToRem(14),
    lineHeight: "24px",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: pxToRem(14),
    lineHeight: "24px",
  },
  [theme.breakpoints.up("xl")]: {
    fontSize: pxToRem(14),
    lineHeight: "24px",
  },
};

theme.typography.body = {
  fontSize: pxToRem(14),
  lineHeight: "24px",
  wordBreak: "break-all",
  fontFamily: [
    "SpoqaHanSansNeo",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  [theme.breakpoints.up("xs")]: {
    fontSize: pxToRem(14),
    lineHeight: "24px",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: pxToRem(14),
    lineHeight: "24px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: pxToRem(14),
    lineHeight: "24px",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: pxToRem(14),
    lineHeight: "24px",
  },
  [theme.breakpoints.up("xl")]: {
    fontSize: pxToRem(14),
    lineHeight: "24px",
  },
};

theme.typography.body2 = {
  fontSize: pxToRem(12),
  lineHeight: "20px",
  wordBreak: "break-all",
  fontFamily: [
    "SpoqaHanSansNeo",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),

  [theme.breakpoints.up("xs")]: {
    fontSize: pxToRem(12),
    lineHeight: "20px",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: pxToRem(12),
    lineHeight: "20px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: pxToRem(12),
    lineHeight: "20px",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: pxToRem(12),
    lineHeight: "20px",
  },
  [theme.breakpoints.up("xl")]: {
    fontSize: pxToRem(12),
    lineHeight: "20px",
  },
};

theme.typography.header = {
  fontSize: pxToRem(14),
  wordBreak: "break-all",
  fontFamily: [
    "SpoqaHanSansNeo",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),

  [theme.breakpoints.up("xs")]: {
    fontSize: pxToRem(11),
    lineHeight: "17px",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: pxToRem(11),
    lineHeight: "17px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: pxToRem(11),
    lineHeight: "17px",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: pxToRem(14),
    lineHeight: "28px",
  },
  [theme.breakpoints.up("xl")]: {
    fontSize: pxToRem(15),
    lineHeight: "28px",
  },
};
